module.exports = __webpack_public_path__ + "static/media/rough-hex.8e14da7f.png";